// extracted by mini-css-extract-plugin
export default {"container":"CustomerDisplay_container__aSK4z","title":"CustomerDisplay_title__hNVo2","logoContainer":"CustomerDisplay_logoContainer__QvJqQ","logo":"CustomerDisplay_logo__SsvV+"};